import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import "./styles/style.css";
import "./styles/custom.css";
import 'tailwindcss/tailwind.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserHistory } from "history";
import CustomRouter from './modules/core/customRouter';
import './i18n';
import ErrorFallback from './modules/core/errorFallback';
import { ThemeProvider, useTheme } from './core/hooks/ThemeContext';
import { ConfigProvider, theme as antdTheme } from 'antd';


const history = createBrowserHistory();

const ThemedApp = () => {
  const { theme } = useTheme();
  return (
    <ConfigProvider
      theme={{
        algorithm: theme === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
      }}
    >
      <CustomRouter history={history}>
        <Suspense fallback="loading">
          <ErrorFallback>
            <App />
          </ErrorFallback>
        </Suspense>
      </CustomRouter>
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ThemeProvider>
    <ThemedApp />
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
